/* istanbul ignore file */
export enum LandingPageOptions {
    map = 'map',
    dashboard = 'dashboard',
    reports = 'reports',
}
